<button class="toro-widget-button-container" [disabled]="disabled" (click)="onClick()">
    <span>{{text}}</span>
</button>
